import { PATH_NAME } from "../configs/pathName";
import { OrderDateRule } from "../models/IOrderDateRule";
import axiosInstance from "./axiosInstance";

export const fetchOrderDateRules = async (): Promise<OrderDateRule[]> => {
    const response = await axiosInstance.get(PATH_NAME.API_ORDER_DATE_RULES);
    return response.data.result;
  };